module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "Title",
      "title": "Title Page"
    }
  }, [_vm._v("Murder on Mt. McKinley")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("A Summit Murder Mystery")]), _vm._v(" "), _c('p', {
    staticClass: "firstauthor"
  }, [_vm._v("Charles G. Irion")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "secondauthor"
  }, [_vm._v("Ronald J. Watkins")]), _vm._v(" "), _c('p', {
    staticClass: "imagecenter"
  }, [_c('img', {
    attrs: {
      "alt": "CGI Irion Books LLC Logo",
      "id": "TitleLogo",
      "src": "Images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('a', {
    attrs: {
      "href": "http://www.SummitMurderMystery.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SummitMurderMystery.com")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IrionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.IrionBooks.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d043d97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TitlePage.vue
// module id = 63
// module chunks = 0